import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import dayjs from '@/js/libs/dayjs';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { DatePicker, FormField, isErrorVisible } from '@/js/libs/ui/src/V2';
import { useController } from '../hooks';
const _DatePickerField = ({ control, name, disabled, renderError, label, labelTooltip, required, withTouched = false, onChange: onChangeProp, isClearable, translations, ...restProps }) => {
    const { field: { onChange, value, ...field }, fieldState, } = useController({ control, name });
    const { isTouched, error } = fieldState;
    const handleChange = useCallbackRef((date) => {
        const parsed = date ? dayjs(date) : null;
        onChange(parsed);
        onChangeProp?.(parsed);
    });
    const selected = value ? value.toDate() : null;
    return (_jsx(FormField, { disabled: disabled, error: error?.message, label: label, labelTooltip: labelTooltip, name: name, renderError: renderError, required: required, touched: isTouched, withTouched: withTouched, children: _jsx(DatePicker, { disabled: disabled, error: isErrorVisible(error?.message, isTouched, withTouched), onChange: handleChange, selected: selected, isClearable: disabled ? false : isClearable, translations: translations, ...restProps, ...field }) }));
};
export const DatePickerField = memo(_DatePickerField);
